import {
    ACTIVATE_TAB,
    WORK_AT_RECYCLE_BIN,
    CHANGE_MODE,
    CLEAR_DATA,
    CLEAR_FORM_AND_IMAGE_MAPPER,
    DELETE_DEPEND_DOCUMENT,
    DELETE_DEPEND_DOCUMENT_FAILED,
    DELETE_DEPEND_DOCUMENT_SUCCESS,
    DOWNLOAD_DEPENDANT_DOCUMENT,
    DOWNLOAD_DEPENDANT_DOCUMENT_FAILED,
    DOWNLOAD_DEPENDANT_DOCUMENT_SUCCESS,
    DOWNLOAD_DOCUMENT,
    DOWNLOAD_DOCUMENT_FAILED,
    DOWNLOAD_DOCUMENT_LINK,
    DOWNLOAD_DOCUMENT_LINK_FAILED,
    DOWNLOAD_DOCUMENT_LINK_SUCCESS,
    DOWNLOAD_DOCUMENT_SUCCESS,
    EDIT_DOCUMENT,
    EDIT_DOCUMENT_FAILED,
    EDIT_DOCUMENT_SUCCESS,
    FOCUS_ON_FIELD_IN_IMAGE,
    GET_DETAIL_DOCUMENT_HISTORY,
    GET_DETAIL_DOCUMENT_HISTORY_FAILED,
    GET_DETAIL_DOCUMENT_HISTORY_SUCCESS,
    LIST_FOLDER_BY_GROUP,
    LIST_FOLDER_BY_GROUP_FAILED,
    LIST_FOLDER_BY_GROUP_SUCCESS,
    MAP_FORM_AND_IMAGE,
    MASS_UPDATE_DOCUMENT,
    MASS_UPDATE_DOCUMENT_FAILED,
    MASS_UPDATE_DOCUMENT_SUCCESS,
    ON_CHANGE_DATA,
    REDIRECT_BACK,
    SCROLL_FORM_OR_IMAGE,
    SHARE_DOCUMENT,
    SHARE_DOCUMENT_FAILED,
    SHARE_DOCUMENT_SUCCESS,
    SHOW_INVOICE_ITEM,
    UPLOAD_DEPEND_DOCUMENT,
    UPLOAD_DEPEND_DOCUMENT_FAILED,
    UPLOAD_DEPEND_DOCUMENT_SUCCESS,
    GET_DOCUMENT_ID,
    GET_DOCUMENT_ID_FAILED,
    GET_DOCUMENT_ID_SUCCESS,
    VIEW_CHILD_DOCUMENT,

    EMPTY_RECYCLE_BIN,
    EMPTY_RECYCLE_BIN_SUCCESS,
    EMPTY_RECYCLE_BIN_FAILED,

    GET_REASON_ID,
    GET_REASON_ID_FAILED,
    GET_REASON_ID_SUCCESS,
    GET_PARKING_ID,
    GET_PARKING_ID_FAILED,
    GET_PARKING_ID_SUCCESS,

    VALIDATE_CONTRACT_NUMBER,
    VALIDATE_CONTRACT_NUMBER_FAILED,
    VALIDATE_CONTRACT_NUMBER_SUCCESS,
    VALIDATE_SHIPPING_DOCUMENT,
    VALIDATE_SHIPPING_DOCUMENT_FAILED,
    VALIDATE_SHIPPING_DOCUMENT_SUCCESS
} from './constants';

type Action = { type: string, payload: {} | string };

export const clearData = (): Action => ({
    type: CLEAR_DATA,
    payload: {},
});

export const workAtRecycleBin = (workAtRecycleBin: Boolean): Action => ({
    type: WORK_AT_RECYCLE_BIN,
    payload: workAtRecycleBin,
});

export const onChangeData = (isValid: Boolean): Action => ({
    type: ON_CHANGE_DATA,
    payload: isValid,
});

export const changeMode = (mode?): Action => ({
    type: CHANGE_MODE,
    payload: mode,
});

export const activateTab = (index: int): Action => ({
    type: ACTIVATE_TAB,
    payload: index,
});

export const viewChildDocument = (view): Action => ({
    type: VIEW_CHILD_DOCUMENT,
    payload: view,
});

export const showInvoiceItems = (): Action => ({
    type: SHOW_INVOICE_ITEM,
    payload: {},
});

export const viewHistory = (viewHistory, historyItemIndex): Action => ({
    type: CHANGE_MODE,
    payload: {viewHistory, historyItemIndex},
});

export const focusOnFieldInImage = (fieldInImage): Action => ({
    type: FOCUS_ON_FIELD_IN_IMAGE,
    payload: fieldInImage,
});

export const mapFormAndImage = (formAndImageMapper): Action => ({
    type: MAP_FORM_AND_IMAGE,
    payload: formAndImageMapper,
});

export const scrollFormOrImage = ({currentFormOffset, currentImageOffset}): Action => ({
    type: SCROLL_FORM_OR_IMAGE,
    payload: {currentFormOffset, currentImageOffset},
});

export const clearFormAndImageMapper = (): Action => ({
    type: CLEAR_FORM_AND_IMAGE_MAPPER,
    payload: {},
});

export const editDocument = (payload: {} | []): CrudAction => ({
    type: EDIT_DOCUMENT,
    payload,
});

export const editDocumentSuccess = (result: {}): CrudAction => ({
    type: EDIT_DOCUMENT_SUCCESS,
    payload: result,
});

export const editDocumentFailed = (payload: {}): CrudAction => ({
    type: EDIT_DOCUMENT_FAILED,
    payload: payload,
});

export const redirectBack = (): Action => ({
    type: REDIRECT_BACK,
    payload: {},
});

export const getDetailDocumentHistory = (id): Action => ({
    type: GET_DETAIL_DOCUMENT_HISTORY,
    payload: {id},
});

export const getDetailDocumentHistorySuccess = (entities: Array): Action => ({
    type: GET_DETAIL_DOCUMENT_HISTORY_SUCCESS,
    payload: entities,
});

export const getDetailDocumentHistoryFailed = (error: string): Action => ({
    type: GET_DETAIL_DOCUMENT_HISTORY_FAILED,
    payload: error,
});

export const uploadDependDocument = (id: String, file, override: Boolean): Action => ({
    type: UPLOAD_DEPEND_DOCUMENT,
    payload: {id, file, override}
});

export const uploadDependDocumentSuccess = (): Action => ({
    type: UPLOAD_DEPEND_DOCUMENT_SUCCESS,
    payload: {},
});

export const uploadDependDocumentFailed = (error: string): Action => ({
    type: UPLOAD_DEPEND_DOCUMENT_FAILED,
    payload: error,
});

export const deleteDependDocument = (payload: {} | []): Action => ({
    type: DELETE_DEPEND_DOCUMENT,
    payload
});

export const deleteDependDocumentSuccess = (): Action => ({
    type: DELETE_DEPEND_DOCUMENT_SUCCESS,
    payload: {},
});

export const deleteDependDocumentFailed = (error: string): Action => ({
    type: DELETE_DEPEND_DOCUMENT_FAILED,
    payload: error,
});

// share documents
export const shareDocument = (documentIds: string[], userIds: string[], withDependants: boolean): Action => ({
    type: SHARE_DOCUMENT,
    payload: {documentIds, userIds, withDependants},
});

export const shareDocumentSuccess = (): Action => ({
    type: SHARE_DOCUMENT_SUCCESS,
    payload: {},
});

export const shareDocumentFailed = (error: string): Action => ({
    type: SHARE_DOCUMENT_FAILED,
    payload: error,
});

// download documents
export const downloadDocument = (documentIds: string[]): Action => ({
    type: DOWNLOAD_DOCUMENT,
    payload: {documentIds},
});

export const downloadDocumentLink = (query: string): Action => ({
    type: DOWNLOAD_DOCUMENT_LINK,
    payload: {query},
});

export const downloadDocumentLinkSuccess = (response): Action => ({
    type: DOWNLOAD_DOCUMENT_LINK_SUCCESS,
    payload: {response},
});

export const downloadDocumentLinkFailed = (error: string): Action => ({
    type: DOWNLOAD_DOCUMENT_LINK_FAILED,
    payload: error,
});

export const downloadDependantDocument = (documentIds: string[]): Action => ({
    type: DOWNLOAD_DEPENDANT_DOCUMENT,
    payload: {documentIds},
});

export const downloadDependantDocumentSuccess = (): Action => ({
    type: DOWNLOAD_DEPENDANT_DOCUMENT_SUCCESS,
    payload: {},
});

export const downloadDependantDocumentFailed = (): Action => ({
    type: DOWNLOAD_DEPENDANT_DOCUMENT_FAILED,
    payload: {},
});

export const downloadDocumentSuccess = (response): Action => ({
    type: DOWNLOAD_DOCUMENT_SUCCESS,
    payload: {response},
});

export const downloadDocumentFailed = (error: string): Action => ({
    type: DOWNLOAD_DOCUMENT_FAILED,
    payload: error,
});


// list folders by group id
export const listFoldersByGroup = (groupId): Action => ({
    type: LIST_FOLDER_BY_GROUP,
    payload: {groupId},
});

export const listFoldersByGroupSuccess = (response): Action => ({
    type: LIST_FOLDER_BY_GROUP_SUCCESS,
    payload: {response},
});

export const listFoldersByGroupFailed = (error: string): Action => ({
    type: LIST_FOLDER_BY_GROUP_FAILED,
    payload: error,
});

export const getDocumentID = (template: str): Action => ({
    type: GET_DOCUMENT_ID,
    payload: template,
});

export const getDocumentIDSuccess = (payload: {}): Action => ({
    type: GET_DOCUMENT_ID_SUCCESS,
    payload: payload,
});

export const getDocumentIDFailed = (payload: {}): Action => ({
    type: GET_DOCUMENT_ID_FAILED,
    payload: payload,
});

export const massUpdateDocument = (file): Action => ({
    type: MASS_UPDATE_DOCUMENT,
    payload: {file},
});

export const massUpdateDocumentSuccess = (result: {}): Action => ({
    type: MASS_UPDATE_DOCUMENT_SUCCESS,
    payload: result,
});

export const massUpdateDocumentFailed = (error: string): Action => ({
    type: MASS_UPDATE_DOCUMENT_FAILED,
    payload: error,
});

export const emptyRecycleBin = (): Action => ({
    type: EMPTY_RECYCLE_BIN,
    payload: {},
});

export const emptyRecycleBinSuccess = (): Action => ({
    type: EMPTY_RECYCLE_BIN_SUCCESS,
    payload: {},
});

export const emptyRecycleBinFailed = (error: string): Action => ({
    type: EMPTY_RECYCLE_BIN_FAILED,
    payload: error,
});

// Unilever Customize Phase 1+ //
export const getReasonID = (): Action => ({
    type: GET_REASON_ID,
    payload: {},
});

export const getReasonIDSuccess = (data: Array): Action => ({
    type: GET_REASON_ID_SUCCESS,
    payload: data,
});

export const getReasonIDFailed = (error: string): Action => ({
    type: GET_REASON_ID_FAILED,
    payload: error,
});

export const getParkingID = (): Action => ({
    type: GET_PARKING_ID,
    payload: {},
});

export const getParkingIDSuccess = (data: Array): Action => ({
    type: GET_PARKING_ID_SUCCESS,
    payload: data,
});

export const getParkingIDFailed = (error: string): Action => ({
    type: GET_PARKING_ID_FAILED,
    payload: error,
});

// Unilever custom //
// In case user must type to linking document //
export const validateContractNumber = (contractNumber: str): Action => ({
    type: VALIDATE_CONTRACT_NUMBER,
    payload: contractNumber,
});

export const validateContractNumberSuccess = (state): Action => ({
    type: VALIDATE_CONTRACT_NUMBER_SUCCESS,
    payload: state,
});

export const validateContractNumberFailed = (error: string): Action => ({
    type: VALIDATE_CONTRACT_NUMBER_FAILED,
    payload: error,
});

export const validateShippingDocument = (shippingDocument: str): Action => ({
    type: VALIDATE_SHIPPING_DOCUMENT,
    payload: shippingDocument,
});

export const validateShippingDocumentSuccess = (state): Action => ({
    type: VALIDATE_SHIPPING_DOCUMENT_SUCCESS,
    payload: state,
});

export const validateShippingDocumentFailed = (error: string): Action => ({
    type: VALIDATE_SHIPPING_DOCUMENT_FAILED,
    payload: error,
});